import React, { useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { CardSpaceWrapper } from '../../../components';
import { useMessageById } from '../../../hooks';
import styles from './style/index.less';
import { useReportService } from './useReportService';
import ActivityModal from './ActivityModal';
import { formateImageWebp } from '../../../utils';
var ActivityCard = function (props) {
    var messageId = props.messageId;
    var messageState = useMessageById(messageId);
    var _a = messageState.payload, _b = _a.content, content = _b === void 0 ? {} : _b, recommendMode = _a.recommendMode, nerMode = _a.nerMode;
    var report = useReportService({ content: content, recommendMode: recommendMode, nerMode: nerMode });
    var _c = useComponents(), View = _c.View, Image = _c.Image;
    var _d = useState(false), showModal = _d[0], setShowModal = _d[1];
    var onShowDetail = function () {
        report.activityClick();
        setShowModal(true);
        report.activityModalExposure();
    };
    return (React.createElement(View, { id: "card_" + content.id },
        React.createElement(CardSpaceWrapper, { className: styles['activity-card'], onClick: onShowDetail },
            React.createElement(View, { className: styles['activity-title'] }, content.title),
            React.createElement(Image, { className: styles['activity-cover'], src: formateImageWebp(content.cover), imageHeight: 368, imageWidth: 656 })),
        React.createElement(ActivityModal, { activity: content, show: showModal, onHide: function () {
                setShowModal(false);
            } })));
};
export default ActivityCard;
